import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EnquiryForm from '../../../components/forms/EnquiryForm';
import { useEnquiryApi } from '../../../hooks/useEnquiryApi';
import { useNavigate, useParams } from 'react-router-dom';
import { EnquiryDTO } from '../../../services/apiClient';

const EnquiryEdit: React.FC = () => {
  const { getById, edit } = useEnquiryApi();
  const [entityData, setEntityData] = useState<EnquiryDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Enquiries', href: '/admin/enquiries' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Enquiry data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/enquiries');
    } catch (error) {
      console.error('Error updating Enquiry:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/enquiries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Enquiry.Edit'
    >
      {entityData ? (
        <EnquiryForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/enquiries')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default EnquiryEdit;